import { motion, useMotionValue, useMotionTemplate } from "framer-motion";
import { Plus, ArrowUpRight } from "lucide-react";
import { eur, imgSrc } from "@/lib/api";
import { useCart } from "@/lib/cart";
import { toast } from "sonner";

export const ProductCard = ({ p, onDetails }) => {
  const { add } = useCart();
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const glow = useMotionTemplate`radial-gradient(260px circle at ${x}px ${y}px, rgba(0,240,255,0.22), transparent 70%)`;

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    x.set(e.clientX - r.left);
    y.set(e.clientY - r.top);
  };
  const addNow = () => {
    add(p);
    toast.success(`${p.name} aggiunto al carrello`);
  };

  return (
    <motion.article layout initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} onMouseMove={onMove} data-testid={`product-card-${p.id}`}
      className="group relative flex flex-col overflow-hidden rounded-[1.75rem] border border-fg/10 bg-[var(--ink-2)] p-3 transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-[var(--volt)]/40">
      <motion.div className="pointer-events-none absolute inset-0 z-10 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{ background: glow }} />
      <button onClick={() => onDetails(p)} data-testid={`product-details-button-${p.id}`}
        className="relative aspect-square overflow-hidden rounded-[1.25rem] bg-black text-left">
        <img src={imgSrc(p.image)} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        {p.badge && (
          <span className="absolute left-3 top-3 rounded-full bg-[#2a2c30]/85 px-3 py-1 font-mono-ui text-[11px] uppercase tracking-widest text-[#ecedee] backdrop-blur">
            {p.badge}
          </span>
        )}
        <span className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#f3f3f4]/80 opacity-0 backdrop-blur transition-opacity group-hover:opacity-100">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </button>
      <div className="relative z-20 flex flex-1 flex-col px-2 pb-1 pt-4">
        <p className="font-mono-ui text-[11px] uppercase tracking-[0.25em] text-mist">{p.categoryLabel || p.category}</p>
        <h3 className="mt-1 font-display text-xl font-semibold">{p.name}</h3>
        <p className="mt-1 text-sm text-mist">{p.tagline}</p>
        <div className="mt-auto flex items-center justify-between pt-5">
          <span className="font-display text-2xl font-semibold" data-testid={`product-price-${p.id}`}>{eur(p.price)}</span>
          <button onClick={addNow} data-testid={`product-add-cart-${p.id}`} aria-label={`Aggiungi ${p.name}`}
            className="flex h-11 w-11 items-center justify-center rounded-full bg-[var(--paper)] text-[var(--ink)] transition-[transform,background-color] hover:rotate-90 hover:bg-[var(--volt)] active:scale-90">
            <Plus className="h-5 w-5" />
          </button>
        </div>
      </div>
    </motion.article>
  );
};
